import type { ListTransfers } from '@cloudFunctions/types/payments/listTransfers';
import type { BackendRouteDefinition } from '../types';

/**
 * Migrated to `api-core-node` in PRA-776 (Phase 5 Sub-phase 1). The
 * cloudFunctions callable was retired in S9-WB2 (PRA-804); the type-only
 * `ListTransfers` namespace at the import path above remains the
 * canonical wire contract.
 */
export const listTransfersRoute = {
  transport: 'api',
  method: 'POST',
  path: '/admin/finix/transfers:lookup',
  body: (requestData: ListTransfers.RequestData) => requestData,
} as const satisfies BackendRouteDefinition;
